export const loginRoute = '/login';

export const loggedInRoute = '';

export const notFoundRoute = '/404';

export const defaultUserRoute = '';



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/config/routes.config.ts